
import {Injectable} from "@angular/core";
@Injectable()
export class EbsWebServiceGlobals {

  //private _baseURL: string = "http://192.168.46.136:5888/stoWebServiceAsp.asmx/";
  private _baseURL: string = "http://192.168.46.105:50496/EfwService_VertreterApp.asmx/";
  private _colorDesign:string = "zanier"; //zanier oder lli
  private _iframeURL: string = "";
  private _loginUrl: string = "";
  private _ebsWebServiceEntryURL = this._baseURL + "GetAsJSON";
  private _ebsWebServiceSearchURL = this._baseURL + "SearchAsJSON";
  private _ebsWebServiceSearchURLParams = "userKey="+ this.getUserHash() +"&path=&district=&param1=&param2=&param3=&param4=&param5=&searchWord=";
  private _ebsWebServiceMainNavigationURL = this._baseURL +"GetMainNavigationAsJSON";
  private _ebsWebServiceMainContentURL = this._baseURL +"GetMainContentAsJSON";

  private _showLoginScreen: boolean =  false;
  private _debugMessage:string= "";
  private _showDebugMessage: boolean = false;
  private _debugUrl:string = "";
  private _username:string = "";
  private _usericon:string = "";
  private _debugPostParams:object;

  constructor(){}

  getEbsWebServiceMainNavigationURL() {

    return this._ebsWebServiceMainNavigationURL;
  }

  getEBSWebServiceMainContentURL() {

    return this._ebsWebServiceMainContentURL;
  }

  getEbsWebServiceEntryURL() {

    return this._ebsWebServiceEntryURL;
  }

  getEbsWebServiceSearchURL() {

    return this._ebsWebServiceSearchURL;
  }

  setEbsWebServiceSearchURL(ebsWebServiceSearchURL) {
    this._ebsWebServiceSearchURL = ebsWebServiceSearchURL;
  }

  getEbsWebServiceSearchURLParams() {
    return this._ebsWebServiceSearchURLParams;
  }

  setEbsWebServiceSearchURLParams(ebsWebServiceSearchURLParams) {
    this._ebsWebServiceSearchURLParams = ebsWebServiceSearchURLParams;
  }

  getShowLoginScreen() {
    return this._showLoginScreen;
  }

  setShowLoginScreen(showLoginScreen) {
    this._showLoginScreen = showLoginScreen;
  }

  setUserHash(userhash) {
    sessionStorage.setItem("userKey",userhash);
  }

  getUserHash() {
    return sessionStorage.getItem("userKey");
  }

  getIframeURL() {
    return this._iframeURL;
  }

  getParameterByName(name) {
    var url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  setUsername(Name) {
    this._username = Name;
  }

  getUsername() {
    return this._username;
  }

  setUsericon(Icon) {
    this._usericon = Icon;
  }

  getUsericon() {
    return this._usericon;
  }

  setDebugMessage(debugMessage) {
    this._debugMessage = debugMessage;
  }

  getDebugMessage() {
    return this._debugMessage;
  }

  setShowDebugMessage(showDebugMessage) {
    this._showDebugMessage = showDebugMessage;
  }

  getShowDebugMessage() {
    return this._showDebugMessage;
  }

  setDebugUrl(debugUrl) {
    this._debugUrl = debugUrl;
  }

  getDebugUrl() {
    return this._debugUrl;
  }

  setDebugPostParams(debugPostParams) {
    this._debugPostParams = debugPostParams;
  }

  getDebugPostParams() {
    return this._debugPostParams;
  }

  setLoginUrl(loginUrl) {
    this._loginUrl = loginUrl;
  }

  getLoginUrl() {
    return this._loginUrl;
  }

  getColorDesign() {
    return this._colorDesign;
  }
}



// WEBPACK FOOTER //
// ./src/services/ebsWebServiceGlobals.ts